import { getValidator, PushNotification } from "@repo/helpers";

import { Form } from "../form";
import { Props } from "./types";

export function ValidatedForm<TObj>(props: Props<TObj>) {
	function onSave() {
		const validationError = validateForm();
		if (!validationError) props.save();
		//dispatch(PushNotification("Please Correct Form Errors"));
		else PushNotification("Validation Error - " + validationError.prop + ": " + validationError.error);
	}

	function validateForm() {
		const { obj, shouldValidate, validators } = props;
		if (!shouldValidate) return null;
		const properties = Object.keys(validators) as (keyof TObj & string)[];

		for (const prop of properties) {
			const validator = getValidator<TObj>(validators)(prop);
			if (validator) {
				const validation = validator(obj[prop]);
				const name = props.friendlyNames[prop] || prop;
				if (validation) return { prop: name, error: validation };
			}
		}

		return null;
	}

	return (
		<Form {...props} save={onSave}>
			{props.children}
		</Form>
	);
}

ValidatedForm.defaultProps = {
	shouldValidate: true,
	friendlyNames: {},
} as Props<any>;
